import { Check, X, Minus } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { COMPARISON } from "@/lib/site";

export default function Comparison() {
  return (
    <section className="relative py-24 sm:py-32 bg-ink-900 border-y border-white/5" data-testid="comparison-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-3xl mb-14">
          <p className="overline mb-4">The honest comparison</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter text-white leading-[0.95]">
            CYAN vs. the rest.
          </h2>
          <p className="mt-5 text-lg text-zinc-400">How local wireless stacks up against cellular and satellite in the high desert.</p>
        </Reveal>

        <Reveal>
          <div className="overflow-x-auto -mx-5 sm:mx-0 px-5 sm:px-0">
            <div className="min-w-[720px] rounded-2xl border border-white/10 overflow-hidden">
              {/* header */}
              <div className="grid grid-cols-4">
                <div className="p-5 bg-ink-850" />
                <div className="p-5 bg-cyan-500 text-ink-950">
                  <div className="font-display font-black text-lg">CYAN Wireless</div>
                  <div className="font-mono-tech text-[11px] uppercase tracking-widest opacity-70">Recommended</div>
                </div>
                <div className="p-5 bg-ink-850 text-zinc-300 font-display font-bold text-lg">Cellular</div>
                <div className="p-5 bg-ink-850 text-zinc-300 font-display font-bold text-lg">Satellite</div>
              </div>

              {COMPARISON.rows.map((r, i) => (
                <div key={r.label} className={`grid grid-cols-4 ${i % 2 ? "bg-ink-850/40" : "bg-ink-950/40"}`}>
                  <div className="p-5 font-medium text-white text-sm border-t border-white/5 flex items-center">{r.label}</div>
                  <div className="p-5 text-sm text-white border-t border-white/5 bg-cyan-500/5 flex items-start gap-2">
                    <Check size={16} className="text-cyan-400 mt-0.5 shrink-0" /> <span className="font-medium">{r.cyan}</span>
                  </div>
                  <div className="p-5 text-sm text-zinc-400 border-t border-white/5 flex items-start gap-2">
                    <Minus size={16} className="text-zinc-600 mt-0.5 shrink-0" /> {r.cell}
                  </div>
                  <div className="p-5 text-sm text-zinc-400 border-t border-white/5 flex items-start gap-2">
                    <X size={16} className="text-zinc-600 mt-0.5 shrink-0" /> {r.sat}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
